export enum FirstStartWizardStep {
    Profile = 'Profile',
    AcceptInvitations = 'AcceptInvitations',
    AcceptPracticeInvitations = 'AcceptPracticeInvitations',
    MobileSuccessInfo = 'MobileSuccessInfo',
}
